import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPictureListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.232 2.782h4.452M7.232 5.008h2.783M7.232 8.346h4.452M7.232 10.573h2.783M4.452 2.226H2.226a.556.556 0 0 0-.556.556v2.226c0 .307.249.556.556.556h2.226c.307 0 .557-.249.557-.556V2.782a.556.556 0 0 0-.557-.556M4.452 7.79H2.226a.556.556 0 0 0-.556.557v2.225c0 .308.249.557.556.557h2.226c.307 0 .557-.25.557-.557V8.347a.556.556 0 0 0-.557-.557"
    />
  </svg>
);
export default SvgPictureListIcon;
